import BaseService from './BaseService';

class DashboardService extends BaseService {
    getDashboardStock = () => this.get('/warehouse/dashboard/dashboardStock');
}

export default new DashboardService();